const normalizeEnums = (value: string) => {
    return value.split("_").map(item => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()).join(" ")
}

export default normalizeEnums;